import React from 'react'
import * as css from '../../FondosAsignados.css'

//Componentes
import { ModalTrigger, ModalGasto, VerFotoGasto } from '../Modales.jsx'

export class RowGastos extends React.Component{
    constructor(props){
        super(props)
        this.state = {
            showModalGasto: false,
            showModalFoto: false
        }
        this.showModalGasto =()=>{
            this.setState({
                showModalGasto: true
            })
        }
        this.hideModalGasto =()=>{
            this.setState({
                showModalGasto: false
            })
        }
    }
    render() {
        return (
            <tr key={this.props.index} onClick={this.showModal}>
                {/* Index */}
                <td className={"hidden-xs "+css.tdIndex}>
                    <img src={this.props.gasto.foto_documento} width="100" height="50" />
                </td>
                {/* FechaGasto */}
                <td className={css.tdFechaGasto}>{this.props.gasto.fecha_emision}</td>
                {/* TipoGasto */}
                <td className={"hidden-xs "+css.tdTipoGasto}>{this.props.gasto.tipo_gasto}</td>
                {/* EstadoGasto */}
                <td className={css.tdEstadoGasto}>{this.props.gasto.estado_gasto}</td>
                {/* Glosa */}
                <td className={"hidden-xs "+css.tdGlosa}>{this.props.gasto.glosa}</td>
                {/* Total */}
                <td className={css.tdTotal}>{this.props.gasto.total? this.props.gasto.total.toLocaleString(navigator.language, { minimumFractionDigits: 0 }) : 0}</td>
                {/* Acciones */}
                <td className={"hidden-xs "+css.tdAcciones}>
                    <div className="col-md-6 col-xs-6">
                        <span className="hidden-xs btn btn-md btn-info" onClick={this.showModalGasto}><span className="glyphicon glyphicon-pencil"/> </span>
                    </div>
                    <div className="col-md-6 col-xs-6">
                        <ModalTrigger>
                            {(isVisible, showModal, hideModal)=>
                                <div>
                                    <span className={"btn btn-md btn-info pull-right"} onClick={showModal}><span className="glyphicon glyphicon-eye-open" title="Ver Imagen"/> </span>
                                    {isVisible && <VerFotoGasto
                                        hideModal={hideModal}
                                        index={this.props.index}
                                        ruta_imagen={this.props.gasto.foto_documento}
                                    />}
                                </div>
                            }
                        </ModalTrigger>
                    </div>
                </td>
                {/* Modal Edicion Gasto */}
                {this.state.showModalGasto && <ModalGasto
                    hideModal={this.hideModalGasto}
                    index={this.props.index}
                    idGastoRendicion={this.props.gasto.idGastoRendicion}
                />}
            </tr>
        )
    }
}


// WEBPACK FOOTER //
// ./frontEnd/operarios/fondos-asignados/detalle-fondo/gastos/RowGastos.jsx